import { AppRoutes } from '../../App/routes';
import { systemBaseRoute } from 'cb-utils/consoleRouteUtils';

export const messagesRoot = 'messages';
export const messageTopic = 'messageTopic';
export const messagesOverviewRoute = `${AppRoutes.CONSOLE_BASE_ROUTE}${systemBaseRoute}/${messagesRoot}`;
export const messagesDetailRoute = `${messagesOverviewRoute}/${encodeURI(`:${messageTopic}*`)}`;
